import React from "react";

const plans = Array(12).fill({
  title: "Sky Ultimate Plan",
  price: "£29/month",
  description:
    "Access Sky TV, Netflix, Disney+ and more. Enjoy unlimited entertainment in one package.",
  image:
    "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4",
});

const Deals = () => {
  return (
    <div className="w-full bg-white text-black">

      {/* HERO VIDEO ONLY */}
      <section className="w-full h-[60vh] md:h-[80vh] overflow-hidden">
        <video
          autoPlay
          loop
          muted
          className="w-full h-full object-cover"
        >
          <source
            src="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blteebcf9e0fcad8443/69ca311aa0fd9e2dc70f403e/2026_Q1_March_WIH1_Deals_Hero_Animation_Desktop_32x9_v1.mp4"
            type="video/mp4"
          />
        </video>
      </section>

      {/* SKY DEALS TEXT SECTION */}
      <section className="py-12 md:py-16 px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold mb-4">
          Sky Deals
        </h2>
        <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
          Only Sky brings together Sky TV, Netflix, Disney+, HBO Max & Hayu in one TV package. That’s over £20 a month worth of streaming apps.
        </p>
      </section>

      {/* CARDS */}
      <section className="px-4 md:px-36 pb-12 md:pb-16">
         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="bg-white border rounded-2xl overflow-hidden hover:shadow-xl transition flex flex-col"
            >
              <img
                src={plan.image}
                alt="plan"
                className="w-full h-40 md:h-48 object-cover"
              />

              <div className="p-5 flex flex-col flex-1">

                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-black font-bold text-base md:text-lg">
                    {plan.price}
                  </h3>
                  <span className="text-red-500 text-xs font-semibold">
                    Limited Offer
                  </span>
                </div>

                <p className="text-black text-sm mb-3 leading-relaxed">
                  {plan.description}
                </p>

                <div className="text-sm text-gray-700 mb-4 space-y-1">
                  <p>✔ Sky TV Included</p>
                  <p>✔ Netflix & Disney+ Access</p>
                  <p>✔ HBO Max + Hayu Bundle</p>
                  <p className="text-red-500 font-semibold">
                    ⚡ Save up to 40% today
                  </p>
                </div>

                <div className="mt-auto flex justify-center">
                  <button className="bg-green-600 text-white px-6 py-2 rounded-lg text-sm md:text-base hover:bg-blue-700 transition w-full md:w-auto">
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* WHY CHOOSE US */}
        <section className="bg-gray-50 py-14 md:py-20 px-4 md:px-6 text-center">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold mb-3">
            Why Choose Us
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto mb-10 text-sm md:text-base">
            Everything you need for premium entertainment in one simple, powerful package.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">

            {/* CARD 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-black transition">
                <svg className="w-6 h-6 text-black group-hover:text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M3 12h18M3 17h18" />
                </svg>
              </div>
              <h3 className="font-semibold text-lg md:text-xl mb-2">
                All-in-One Package
              </h3>
              <p className="text-gray-600 text-sm md:text-base">
                Get all major streaming platforms in one affordable plan.
              </p>
            </div>

            {/* CARD 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-black transition">
                <svg className="w-6 h-6 text-black group-hover:text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.4 15a7.978 7.978 0 01-2.2 2.2l1.4 2.4-2 1.2-1.4-2.4a7.978 7.978 0 01-3 .6 7.978 7.978 0 01-3-.6l-1.4 2.4-2-1.2 1.4-2.4A7.978 7.978 0 014.6 15l-2.4-1.4 1.2-2 2.4 1.4A7.978 7.978 0 016 10c0-1.05.2-2.05.6-3L4.2 5.6l1.2-2 2.4 1.4A7.978 7.978 0 0110 4.6c1.05 0 2.05.2 3 .6l1.4-2.4 2 1.2-1.4 2.4c.9.6 1.6 1.3 2.2 2.2l2.4-1.4 1.2 2-2.4 1.4c.4.95.6 1.95.6 3s-.2 2.05-.6 3l2.4 1.4-1.2 2-2.4-1.4z" />
                </svg>
              </div>
              <h3 className="font-semibold text-lg md:text-xl mb-2">
                Affordable Pricing
              </h3>
              <p className="text-gray-600 text-sm md:text-base">
                Save money compared to buying subscriptions separately.
              </p>
            </div>

            {/* CARD 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-black transition">
                <svg className="w-6 h-6 text-black group-hover:text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="font-semibold text-lg md:text-xl mb-2">
                Premium Experience
              </h3>
              <p className="text-gray-600 text-sm md:text-base">
                Enjoy seamless entertainment with HD and 4K content.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 md:py-20 px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
          FAQs
        </h2>

        <div className="space-y-3">
          
          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              What is included in Sky Deals?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Sky Deals includes access to Sky TV, Netflix, Disney+, HBO Max, and Hayu.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Can I cancel anytime?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Yes, you can cancel your subscription at any time.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Do you offer HD or 4K?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Yes, we offer HD and 4K streaming depending on your plan.
            </p>
          </details>

          <details className="group border border-gray-200 rounded-xl p-4 md:p-5 bg-white hover:shadow-sm transition">
            <summary className="cursor-pointer flex justify-between items-center font-medium text-sm md:text-base list-none">
              Is this available worldwide?
              <span className="text-gray-400 group-open:rotate-45 transition">+</span>
            </summary>
            <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed">
              Availability may vary depending on your region.
            </p>
          </details>

        </div>
      </section>


    </div>
  );
};

export default Deals;
